import {useContext} from 'react';
import type {Component} from 'grapesjs';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';

export function useSelectedComponent(): Component | null {
  const {state} = useContext(emailMakerContext);
  return state.selectedComponent;
}
